import { render, staticRenderFns } from "./TemplateImages.vue?vue&type=template&id=2c44f961&scoped=true&"
import script from "./TemplateImages.vue?vue&type=script&lang=js&"
export * from "./TemplateImages.vue?vue&type=script&lang=js&"
import style0 from "./TemplateImages.vue?vue&type=style&index=0&id=2c44f961&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44f961",
  null
  
)

export default component.exports